import type {Question, QuestionStatus} from '@cp/model';
import {questionChangeStatus} from '../../api/callable/question';
import {useFunctionWrap} from '../helper/function/useFunctionWrap';

export function useChangeQuestionStatus() {
  const {
    fn: changeQuestionStatusFn,
    loading,
    error,
  } = useFunctionWrap(
    async (moduleId: string, questionId: string, status: QuestionStatus, statusNote?: string): Promise<Question> =>
      questionChangeStatus({
        moduleId,
        questionId,
        status,
        statusNote,
      }) as Promise<Question>,
  );

  return {
    changeQuestionStatus: changeQuestionStatusFn,
    loading,
    error,
  };
}
